declare namespace $ {

	type $bog_max_nav_item__arg_bog_max_nav_1 = $mol_type_enforce<
		({ 
			'section': any,
			'screen': any,
			'ticket': any,
		}) 
		,
		ReturnType< $bog_max_nav_item['arg'] >
	>
	type $bog_max_nav_item__label_bog_max_nav_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_max_nav_item['label'] >
	>
	type $bog_max_nav_item__active_bog_max_nav_3 = $mol_type_enforce<
		ReturnType< $bog_max_nav['tickets_active'] >
		,
		ReturnType< $bog_max_nav_item['active'] >
	>
	type $bog_max_nav_item__Icon_bog_max_nav_4 = $mol_type_enforce<
		ReturnType< $bog_max_nav['Tickets_icon'] >
		,
		ReturnType< $bog_max_nav_item['Icon'] >
	>
	type $bog_max_nav_item__arg_bog_max_nav_5 = $mol_type_enforce<
		({ 
			'section': string,
			'screen': any,
			'ticket': any,
		}) 
		,
		ReturnType< $bog_max_nav_item['arg'] >
	>
	type $bog_max_nav_item__label_bog_max_nav_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_max_nav_item['label'] >
	>
	type $bog_max_nav_item__active_bog_max_nav_7 = $mol_type_enforce<
		ReturnType< $bog_max_nav['house_active'] >
		,
		ReturnType< $bog_max_nav_item['active'] >
	>
	type $bog_max_nav_item__Icon_bog_max_nav_8 = $mol_type_enforce<
		ReturnType< $bog_max_nav['House_icon'] >
		,
		ReturnType< $bog_max_nav_item['Icon'] >
	>
	type $bog_max_nav_item__arg_bog_max_nav_9 = $mol_type_enforce<
		({ 
			'section': string,
			'screen': any,
			'ticket': any,
		}) 
		,
		ReturnType< $bog_max_nav_item['arg'] >
	>
	type $bog_max_nav_item__label_bog_max_nav_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_max_nav_item['label'] >
	>
	type $bog_max_nav_item__active_bog_max_nav_11 = $mol_type_enforce<
		ReturnType< $bog_max_nav['dispatch_active'] >
		,
		ReturnType< $bog_max_nav_item['active'] >
	>
	type $bog_max_nav_item__Icon_bog_max_nav_12 = $mol_type_enforce<
		ReturnType< $bog_max_nav['Dispatch_icon'] >
		,
		ReturnType< $bog_max_nav_item['Icon'] >
	>
	type $bog_max_nav_item__arg_bog_max_nav_13 = $mol_type_enforce<
		({ 
			'section': string,
			'screen': any,
			'ticket': any,
		}) 
		,
		ReturnType< $bog_max_nav_item['arg'] >
	>
	type $bog_max_nav_item__label_bog_max_nav_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_max_nav_item['label'] >
	>
	type $bog_max_nav_item__active_bog_max_nav_15 = $mol_type_enforce<
		ReturnType< $bog_max_nav['admin_active'] >
		,
		ReturnType< $bog_max_nav_item['active'] >
	>
	type $bog_max_nav_item__Icon_bog_max_nav_16 = $mol_type_enforce<
		ReturnType< $bog_max_nav['Admin_icon'] >
		,
		ReturnType< $bog_max_nav_item['Icon'] >
	>
	type $bog_max_nav_item__arg_bog_max_nav_17 = $mol_type_enforce<
		({ 
			'section': string,
			'screen': any,
			'ticket': any,
		}) 
		,
		ReturnType< $bog_max_nav_item['arg'] >
	>
	type $bog_max_nav_item__label_bog_max_nav_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_max_nav_item['label'] >
	>
	type $bog_max_nav_item__active_bog_max_nav_19 = $mol_type_enforce<
		ReturnType< $bog_max_nav['account_active'] >
		,
		ReturnType< $bog_max_nav_item['active'] >
	>
	type $bog_max_nav_item__Icon_bog_max_nav_20 = $mol_type_enforce<
		ReturnType< $bog_max_nav['Account_icon'] >
		,
		ReturnType< $bog_max_nav_item['Icon'] >
	>
	export class $bog_max_nav extends $mol_view {
		tabs( ): readonly(any)[]
		tickets_active( ): string
		Tickets_icon( ): $mol_icon_clipboard_text
		house_active( ): string
		House_icon( ): $mol_icon_home_city
		dispatch_active( ): string
		Dispatch_icon( ): $mol_icon_account_tie
		admin_active( ): string
		Admin_icon( ): $mol_icon_account_cog
		account_active( ): string
		Account_icon( ): $mol_icon_account_circle
		section( ): string
		staff( ): boolean
		admin( ): boolean
		sub( ): ReturnType< $bog_max_nav['tabs'] >
		Tab_tickets( ): $bog_max_nav_item
		Tab_house( ): $bog_max_nav_item
		Tab_dispatch( ): $bog_max_nav_item
		Tab_admin( ): $bog_max_nav_item
		Tab_account( ): $bog_max_nav_item
	}
	
}

//# sourceMappingURL=nav.view.tree.d.ts.map